<template>
	<div>
		<div class="actDiv">
			<label style="font-size: 0.8rem;">给水号：</label>
			<a-input-search  style="width: 15rem;"  @search="queryData()" 
						v-model="apId" placeholder="根据给水号查询" enter-button/>
			<a-button size="small"   icon="plus" @click="showAddView()" style="margin: 0 0.75rem;">新增监控点</a-button>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="600"   ref="mTable" show-overflow="title" size="mini" stripe
						  resizable  :loading="loading"   row-id="id">
				<vxe-table-column type="seq" width="45"></vxe-table-column>
				<vxe-table-column title="给水号" field="meterApid"  width="120"></vxe-table-column>
				<vxe-table-column title="表地址" field="meterAddr"   width="140"></vxe-table-column>
				<vxe-table-column title="监控点名称" field="monitorName"  width="240"></vxe-table-column>
				<vxe-table-column title="监控点地址" field="monitorAddress"></vxe-table-column>
				<vxe-table-column title="口径" field="caliber"  width="120"></vxe-table-column>
				<vxe-table-column title="表状态" field="meterStatus"  :formatter="getMeterState" width="120"></vxe-table-column>
				<vxe-table-column title="所属分组" field="groupName" width="160"></vxe-table-column>
				<vxe-table-column title="操作" field="id" width="120">
					<template #default="{ row }">
						<a-button size="small" type="link" @click="showEditView(row)" >编辑</a-button>
					</template>
				</vxe-table-column>
		</vxe-table>
		<MeterMonitorAddView ref="addView" @refreshIt="queryData()"/>
		<MeterMonitorEditView ref="editView" @refreshIt="queryData()"/>
	</div>
</template>

<script>
	import MeterMonitorAddView from '../components/MeterMonitorAddView.vue'
	import MeterMonitorEditView from '../components/MeterMonitorEditView.vue'
	export default {
		components: {
			MeterMonitorAddView,
			MeterMonitorEditView,
		},
		data(){
			return {
				apId:null,
				dataList:[],
				loading:false,
			}
		},
		methods: {
			queryData() {
				this.loading = true;
				let param = {
					apId:this.apId,
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_ALL_LIST_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getMeterState({cellValue}){
				if(status == '1'){
					return "已链接";
				}else{
					return "无链接";
				}
			},
			showAddView(){
				this.$refs.addView.showView();
			},
			showEditView(row){
				let temp = this.Config.deepClone(row);
				this.$refs.editView.showView(temp);
			},
		},
		created(){
			this.queryData();
		},
	}
</script>

<style>
</style>
